import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import "./App.css";
import 'aos/dist/aos.css';
import Aos from 'aos';
import Header from './components/Header/Header.jsx';
import Hero from './components/UI/Hero.jsx';
import Experience from './components/UI/Experience.jsx';
import Skills from './components/UI/Skills.jsx';
import Education from './components/UI/Education.jsx';
import Portfolio from './components/UI/Portfolio';
import Contact from './components/UI/Contact';
import Footer from './components/Footer/Footer';
import SEO from './components/SEO/SEO';
import ReactGA from 'react-ga';
import AdminPanel from './components/Admin/AdminPanel';
import { Analytics } from "@vercel/analytics/react";
function App() {
  const isMobile = useMediaQuery({ maxWidth: 640 });

  const [isAdminRoute, setIsAdminRoute] = useState(window.location.hash === '#admin');

  useEffect(() => {
    document.title = "Mohamed Leachouri | Portfolio"
    Aos.init();
    ReactGA.initialize('G-CR91YKDB4Q');
    ReactGA.pageview(window.location.pathname + window.location.search);

    const handleHashChange = () => setIsAdminRoute(window.location.hash === '#admin');
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);


  if (isAdminRoute) {
    return (
      <div className='overflow-hidden font-mono bg-white dark:bg-gray-800 transition-colors duration-300'>
        <SEO />
        <AdminPanel />
      </div>
    );
  }

  return (
    <div className='overflow-hidden font-mono bg-white dark:bg-gray-800 transition-colors duration-300'>
      <SEO />
      <div className={`min-h-screen ${isMobile ? 'overflow-hidden' : ''} bg-white dark:bg-gray-800 transition-colors duration-300`}>
        <Header />
        <main>
          <Hero />
          <Experience />
          <Skills />
          <Education />
          <Portfolio />
          <Contact />
        </main>
        <Footer />
        <Analytics />
      </div>
    </div>
  );
}

export default App;
